// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"Footer_textContainer__2gmTA","logo":"Footer_logo__SCo_Y"};